<frog-landing-toolbar></frog-landing-toolbar>
<div class="root">
    <div class="flex justify-space-evenly">
        <div class="flex middle">
            <div class="flex column form">
                @if (sent) {
                    <h4>
                        Your request has been sent to our sales team, someone will be responding to
                        your request shortly
                    </h4>
                } @else {
                    <form [formGroup]="form" class="flex column">
                        <div class="flex top-form">
                            <mat-form-field appearance="fill">
                                <mat-label>First Name</mat-label>
                                <input matInput type="text" formControlName="firstName" required />
                                <mat-error>Please enter your first name</mat-error>
                            </mat-form-field>
                            <mat-form-field appearance="fill">
                                <mat-label>Last Name</mat-label>
                                <input matInput type="text" formControlName="lastName" required />
                                <mat-error>Please enter your last name</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="flex top-form">
                            <mat-form-field appearance="fill">
                                <mat-label>Email</mat-label>
                                <input matInput type="email" formControlName="email" required />
                                <mat-error>Please enter a valid email address</mat-error>
                            </mat-form-field>
                            <mat-form-field appearance="fill">
                                <mat-label>Phone</mat-label>
                                <input
                                    matInput
                                    type="phone"
                                    placeholder="555-555-1234"
                                    formControlName="phone"
                                />
                                <mat-error>Please enter a valid phone number</mat-error>
                            </mat-form-field>
                        </div>
                        <mat-form-field appearance="fill">
                            <mat-label>Team Size</mat-label>
                            <mat-select formControlName="teamSize">
                                <mat-option value="1-10">1-10</mat-option>
                                <mat-option value="11-50">11-50</mat-option>
                                <mat-option value="51-250">51-250</mat-option>
                                <mat-option value="251-500">251-500</mat-option>
                                <mat-option value="500+">500+</mat-option>
                                <mat-option value="Not sure yet">Not sure yet</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="fill">
                            <mat-label>Industry</mat-label>
                            <mat-select formControlName="industry">
                                <mat-option value="Media and Entertainment"
                                    >Media and Entertainment</mat-option
                                >
                                <mat-option value="Non-profit">Non-profit</mat-option>
                                <mat-option value="Education">Education</mat-option>
                                <mat-option value="Other">Other</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="fill">
                            <mat-label>What can we help with?</mat-label>
                            <mat-select formControlName="subject" required>
                                <mat-option value="Sales Request">Sales Request</mat-option>
                                <mat-option value="Support Request">Support Request</mat-option>
                                <mat-option value="FrogEye for Education or Non-Profit"
                                    >FrogEye for Education or Non-Profit</mat-option
                                >
                                <mat-option value="Other">Other</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="fill">
                            <mat-label>Message</mat-label>
                            <textarea matInput formControlName="message"></textarea>
                        </mat-form-field>
                        <div class="flex row">
                            <button
                                mat-raised-button
                                color="primary"
                                type="submit"
                                class="flex-33"
                                [disabled]="form.invalid"
                                (click)="submit()"
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                }
            </div>
            <div class="flex column info">
                <div>
                    <h1>Contact our sales team</h1>
                </div>
                <mat-list>
                    <mat-list-item>
                        <mat-icon matListItemIcon>check</mat-icon>
                        Ask about enterprise solutions
                    </mat-list-item>
                    <mat-list-item>
                        <mat-icon matListItemIcon>check</mat-icon>
                        Explore use cases for you team
                    </mat-list-item>
                    <mat-list-item>
                        <mat-icon matListItemIcon>check</mat-icon>
                        Get pricing information
                    </mat-list-item>
                </mat-list>
            </div>
        </div>
    </div>

    <frog-try-block></frog-try-block>
    <frog-footer></frog-footer>
</div>
